import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const jwtToken = localStorage.getItem('jwtToken');
    
    // Log especial para uploads
    if (req.url.includes('/upload')) {
      console.log('🔐 AuthInterceptor: Request a /upload detectada');
      console.log('🔑 AuthInterceptor: JWT Token presente:', !!jwtToken);
      console.log('🌐 AuthInterceptor: URL completa:', req.url);
    }
    
    // Excluir las rutas de autenticación que no necesitan JWT
    if (req.url.includes('/api/auth/azure/login') || 
        req.url.includes('/api/auth/azure-login') ||
        req.url.includes('/api/auth/validate-jwt')) {
      console.log('🔓 AuthInterceptor: Excluyendo autenticación para:', req.url);
      return next.handle(req);
    }
    
    if (jwtToken) {
      console.log('✅ AuthInterceptor: Añadiendo Authorization Bearer a:', req.url);
      const cloned = req.clone({
        setHeaders: {
          Authorization: `Bearer ${jwtToken}`
        }
      });
      return next.handle(cloned);
    }
    console.log('⚠️ AuthInterceptor: NO se añade Authorization a:', req.url);
    return next.handle(req);
  }
}